export const Hamburger = () => (
  <g>
    <path
      d='M6 17H18V15.3333H6V17ZM6 12.8333H18V11.1667H6V12.8333ZM6 7V8.66667H18V7H6Z'
      fill='currentColor'
    />
  </g>
)
